import React from "react";
import { SidebarIcon } from "../SidebarIcon/SidebarIcon";
import { Dropdown } from "primereact/dropdown";
import { GroupSelectorProps } from "../types/GroupSelectorProps";
import "./GroupSelectorDropdown.css";
import vesselIcon from "../assets/vessel.svg";

export const GroupSelectorDropdown = (props: GroupSelectorProps) => {
    const { selectedGroup, onGroupChange, groups } = props;
    const [groupSelection, setGroupSelection] =
        React.useState<string>(selectedGroup);

    const bodyTemplate = (options: any) => {
        return (
            <div className="flex align-items-center">
                <SidebarIcon
                    src={vesselIcon}
                    fill={"#555555"}
                    style={"display: block;"}
                />
                <p className={"ml-3 group-name"}> {options.name} </p>
            </div>
        );
    };

    const handleGroupChange = (e: any) => {
        setGroupSelection(e.value.code);
        onGroupChange(e);
    };

    return (
        <div className="card flex justify-content-center">
            <Dropdown
                itemTemplate={bodyTemplate}
                options={groups}
                value={groups.find((group) => group.code === groupSelection)}
                onChange={handleGroupChange}
                valueTemplate={bodyTemplate}
                optionLabel="name"
                className="w-12rem md:w-15rem max-w-15rem group-selector-dropdown"
            />
        </div>
    );
};
